import React from 'react';
import './GlassBox.css';

const GlassBox = ({ onLoginClick }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onLoginClick();
    }
  };

  const handleLearnMoreClick = () => {
    // Navigate to about page or scroll to more information
    window.location.href = '/about';
  };

  const handleLearnMoreKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleLearnMoreClick();
    }
  };

  return (
    <div className="glass-box" role="main" aria-label="Main content">
      <div className="glass-content">
        {/* Main Content Area */}
        <div className="glass-main-content">
          {/* <div className="content-header">
            <span className="sub-heading">RDV Systems presents</span>
          </div> */}
          
          <h1 className="glass-title">
           Infrastructure Safety & Visualization <strong>Solution</strong>
          </h1>
          
          <p className="content-description">
          Advanced road safety audit and analysis with cutting-edge 3D AI technology. <strong>Monitor</strong>, <strong>analyze</strong>, <strong>detect</strong>, and <strong>report</strong> on critical elements with greater accuracy and speed.
          </p>
          
          <div className="cta-buttons" role="group" aria-label="Action buttons">
            <button 
              className="primary-btn" 
              onClick={onLoginClick}
              onKeyDown={handleKeyDown}
              aria-label="Login to your account to access the analysis platform"
            >
              Account Login
            </button>
            <button 
              className="secondary-btn"
              onClick={handleLearnMoreClick}
              onKeyDown={handleLearnMoreKeyDown}
              aria-label="Learn more about our infrastructure safety analysis services"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlassBox;
